"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.BankAcctTypeField = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _AccountNumber = _interopRequireDefault(require("../../AccountNumber"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Form = _interopRequireDefault(require("../../Form"));

var _FormControl = _interopRequireDefault(require("../../FormControl"));

var _FormHelperText = _interopRequireDefault(require("../../FormHelperText"));

var _Grid = _interopRequireDefault(require("../../Grid"));

var _Radio = _interopRequireDefault(require("../../Radio"));

var _RoutingNumber = _interopRequireDefault(require("../../RoutingNumber"));

var _Spacing = _interopRequireDefault(require("../../Spacing"));

var _SubmitButton = _interopRequireDefault(require("../../SubmitButton"));

var _Typography = _interopRequireDefault(require("../../Typography"));

var _styles2 = require("../../styles");

var _i18n = require("../../constants/i18n");

var _GiactFormValidation = _interopRequireDefault(require("./GiactFormValidation"));

var AccountRouting = function AccountRouting(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("title", null, "Group"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EEE",
    opacity: ".872",
    d: "M0 0h326v57H0z"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    opacity: ".87",
    fontFamily: "Lato-Regular, Lato",
    fontSize: "14",
    letterSpacing: ".24",
    fill: "#212121"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: "41",
    y: "75"
  }, "Account number")), /*#__PURE__*/_react["default"].createElement("text", {
    opacity: ".87",
    fontFamily: "Lato-Regular, Lato",
    fontSize: "14",
    letterSpacing: ".24",
    fill: "#212121"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: "182",
    y: "75"
  }, "Routing number")), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#424242",
    opacity: ".872",
    d: "M24 21h6v15h-6zM34 17h6v8h-6z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    opacity: ".872",
    fill: "#424242"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M148 17h6v8h-6zM148 32h6v8h-6zM158 21h6v15h-6z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#424242",
    opacity: ".872",
    d: "M296 16h6v8h-6zM34 32h6v8h-6z"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    opacity: ".87",
    fontFamily: "Lato-Regular, Lato",
    fontSize: "16",
    letterSpacing: ".479",
    fill: "#212121",
    transform: "translate(24 16)"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: "26",
    y: "16"
  }, "123456780")), /*#__PURE__*/_react["default"].createElement("text", {
    opacity: ".87",
    fontFamily: "Lato-Regular, Lato",
    fontSize: "16",
    letterSpacing: ".479",
    fill: "#212121",
    transform: "translate(24 16)"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: "165",
    y: "16"
  }, "012345678")), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "#595959",
    strokeLinecap: "square",
    strokeWidth: "3"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M287.5 26v6M291.5 26v6"
  }))));
};

AccountRouting.defaultProps = {
  width: "326",
  height: "83",
  viewBox: "0 0 326 83",
  xmlns: "http://www.w3.org/2000/svg"
};

var styles = function styles(theme) {
  var _btnCancel;

  return {
    textField: {
      marginTop: theme.spacing(2)
    },
    fieldsContainer: (0, _defineProperty2["default"])({}, theme.breakpoints.up('md'), {
      marginTop: theme.spacing(3),
      paddingRight: theme.spacing(6)
    }),
    textFieldsContainer: {
      marginTop: theme.spacing(2)
    },
    btnContainer: {
      marginTop: theme.spacing(5)
    },
    btnSubmit: (0, _defineProperty2["default"])({}, theme.breakpoints.up('sm'), {
      width: theme.spacing(23.75)
    }),
    btnCancelText: {
      color: theme.palette.grey[500]
    },
    btnCancel: (_btnCancel = {}, (0, _defineProperty2["default"])(_btnCancel, theme.breakpoints.down('xs'), {
      marginTop: theme.spacing(2)
    }), (0, _defineProperty2["default"])(_btnCancel, theme.breakpoints.up('sm'), {
      marginRight: theme.spacing(2),
      width: theme.spacing(15)
    }), _btnCancel),
    emptyTextUtil: {
      '&::before': {
        content: '""',
        display: 'inline-block'
      }
    }
  };
};

exports.styles = styles;
var useStyles = (0, _styles2.makeStyles)(styles);

var BankAcctTypeField = function BankAcctTypeField(_ref) {
  var bankAccountTypeKey = _ref.bankAccountTypeKey;
  var classes = useStyles();

  var _useFormikContext = (0, _formik.useFormikContext)(),
      touched = _useFormikContext.touched,
      errors = _useFormikContext.errors;

  var bankAccountTypeError = errors[bankAccountTypeKey];
  var bankAccountTypeHelperText = errors[bankAccountTypeKey];
  var bankAccountTypeTouched = touched[bankAccountTypeKey];
  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    error: Boolean(bankAccountTypeError)
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
    dataQa: "bank-account-type-checking",
    value: "Checking",
    name: bankAccountTypeKey
  }, _i18n.BANK_LINK.checking), /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
    dataQa: "bank-account-type-savings",
    value: "Savings",
    name: bankAccountTypeKey
  }, _i18n.BANK_LINK.savings)), /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginLeft: 2
  }, /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], null, bankAccountTypeTouched && bankAccountTypeHelperText || /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.emptyTextUtil
  }))));
};

exports.BankAcctTypeField = BankAcctTypeField;

var GiactForm = function GiactForm(_ref2) {
  var _ref3;

  var handleClose = _ref2.handleClose,
      onSubmit = _ref2.onSubmit,
      loading = _ref2.loading,
      bankAccountTypeKey = _ref2.bankAccountTypeKey,
      bankRoutingNumberKey = _ref2.bankRoutingNumberKey,
      bankAccountNumberKey = _ref2.bankAccountNumberKey,
      confirmAccountNumberKey = _ref2.confirmAccountNumberKey;
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _core.useMediaQuery)(theme.breakpoints.down('xs'));
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
    onSubmit: onSubmit,
    validationSchema: (0, _GiactFormValidation["default"])(),
    initialValues: (_ref3 = {}, (0, _defineProperty2["default"])(_ref3, bankAccountTypeKey, ''), (0, _defineProperty2["default"])(_ref3, bankRoutingNumberKey, ''), (0, _defineProperty2["default"])(_ref3, bankAccountNumberKey, ''), (0, _defineProperty2["default"])(_ref3, confirmAccountNumberKey, ''), _ref3)
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5"
  }, _i18n.BANK_LINK.enterBankInfo), /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginTop: 2
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, _i18n.BANK_LINK.pleaseProvideInfo)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: isMobile && 'column'
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    item: true,
    md: 8,
    className: classes.fieldsContainer
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "overline"
  }, _i18n.BANK_LINK.selectAccountType), /*#__PURE__*/_react["default"].createElement(BankAcctTypeField, {
    bankAccountTypeKey: bankAccountTypeKey
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    className: classes.textFieldsContainer
  }, /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginTop: 2
  }, /*#__PURE__*/_react["default"].createElement(_RoutingNumber["default"], {
    dataQa: "bank-routing-number-field",
    id: "bank-routing-number-field",
    label: "Routing number",
    name: bankRoutingNumberKey
  }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    className: classes.textField
  }, /*#__PURE__*/_react["default"].createElement(_AccountNumber["default"], {
    dataQa: "bank-account-number-field",
    id: "bank-account-number-field",
    label: "Account number",
    name: bankAccountNumberKey
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    className: classes.textField
  }, /*#__PURE__*/_react["default"].createElement(_AccountNumber["default"], {
    dataQa: "confirm-account-number-field",
    id: "confirm-account-number-field",
    integer: true,
    label: "Confirm account number",
    name: confirmAccountNumberKey
  })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: isMobile ? 'column' : 'row-reverse',
    className: classes.btnContainer
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.btnSubmit
  }, /*#__PURE__*/_react["default"].createElement(_SubmitButton["default"], {
    dataQa: "giact-submit-btn",
    disabled: loading,
    fullWidth: true
  }, _i18n.BANK_LINK.giactConnectBank)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    className: classes.btnCancel
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "text",
    dataQa: "giact-cancel-btn",
    onClick: handleClose,
    fullWidth: true,
    className: classes.btnCancelText
  }, _i18n.BANK_LINK.giactCancel))));
};

var _default = GiactForm;
exports["default"] = _default;